import SignupForm from "../components/signup/Signupform";
import React from "react";


function SignupPage(){
    return(
        <SignupForm />
    )
}
export default SignupPage;